export default __webpack_public_path__ + "static/media/shoes1-afterA-1440w.6753a357.webp";